<template>
    <div>
        <v-toolbar class="main">
          <button class="nav-back" @click="goBack"><v-icon>keyboard_arrow_left</v-icon> Logga ut</button>
        </v-toolbar>
        <center>
            <h1>Välkommen {{ $store.state.activeProfile.username }} </h1>
            <br>
            <h2>Välj Roll</h2>
        </center>
        <br>
        <v-btn block color="primary" @click="setRoleDriver">Chaufför</v-btn>
        <br>
        <v-btn block color="primary" @click="setRoleWarehouse">Lager</v-btn>
    </div>
</template>

<script>
export default {
    methods:{
        setRoleDriver(){
            this.$store.state.activeProfile.role = 'hybrid-driver';
            this.$router.push('Driver_Home');
        },
        setRoleWarehouse(){
            this.$store.state.activeProfile.role = 'hybrid-warehouse';
            this.$router.push('Warehouse_Home');
        },
        goBack(){
            this.$store.commit('unsetActiveProfile');
            this.$router.push('/');
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ChooseRole.vue